// extracted by mini-css-extract-plugin
module.exports = {"config-table__subtitle":"Table_config-table__subtitle_vy_bp","config-table__subtitle-label":"Table_config-table__subtitle-label_16YjF"};